import React, { memo } from 'react';
import PropTypes from 'prop-types';

import styles from './FormField.module.scss';

function FormField({
  children, label, isRequired, isHiddenLabel, className,
}) {
  return (
    <div className={`${styles.Component} ${className}`}>
      {
        !isHiddenLabel && (
          <label className={`${isRequired ? 'require' : ''}`} htmlFor={children.props?.id}>
            {label}
          </label>
        )
      }

      { children }
    </div>
  );
}

FormField.propTypes = {
  isHiddenLabel: PropTypes.bool,
  isRequired: PropTypes.bool,

  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
};

FormField.defaultProps = {
  isHiddenLabel: false,
  isRequired: false,

  className: '',
  label: '',
};

export default memo(FormField);
